<template>
    <div>
        <!-- IMPORTANTE!!!!!!!!!!!!!!!!!!!! QUEDA INCONCLUSO POR EL TEMA DE QUE SON MUCHOS APARTADOS Y SE DESBORDAN -->
        <!-- HEADER TITULO -->
        <div class="titulo-contenido d-none">
            <h1>
                <span class="negrita">RENDICIÓN DE </span><span class="normal">CUENTAS</span>
            </h1>
        </div>
        <!-- DROPDOWN -->
        <div class="d-none" style="text-align:right; margin-right:5%;">
            <div class="dropdown">
                <button style="border-bottom: 3px solid #621132; border-radius:0px; color: #621132; font-size:18px;" class="mb-2 btn btn-white dropdown-toggle" type="button" id="dropdownMenu2" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    Rendicion de cuentas opciones
                </button>
                <div class="dropdown-menu" aria-labelledby="dropdownMenu2">
                    <button class="dropdown-item" @click="opciones(1)" type="button">Presupuesto de Egresos</button>
                    <button class="dropdown-item" @click="opciones(2)" type="button">Informes de Finanzas Públicas</button>
                    <button class="dropdown-item" @click="opciones(3)" type="button">Informe de avance de gestión financiera</button>
                    <button class="dropdown-item" @click="opciones(4)" type="button">Recursos a Municipios</button>
                    <button class="dropdown-item" @click="opciones(5)" type="button">Estrategico institucional por Organismo Público</button>
                    <button class="dropdown-item" @click="opciones(6)" type="button">Cuentas públicas</button>
                    <button class="dropdown-item" @click="opciones(7)" type="button">Informe de avance trimestral-Cuenta Pública</button>
                </div>
            </div>
        </div>
        <presupuesto-egreso v-if="PresupuestoEgreso"></presupuesto-egreso>
        <finanzas-publicas v-if="finanzas"></finanzas-publicas>
        <gestion-financiera v-if="gestionfinanciera"></gestion-financiera>
        <recursos-municipios v-if="recursos"></recursos-municipios>
        <estrategico-munucipal v-if="estrategicaMpal"></estrategico-munucipal>
        <cuentas-publicas v-if="ctaspublicas"></cuentas-publicas>
        <trimestral-cuentas v-if="trimestral"></trimestral-cuentas>

        <!-- ------------------------------------------- -->
        <!--  CONTENIDO DE CONSTRUCCION A PARTIR DE AQUI -->
        <!-- ------------------------------------------- -->
        <pagina-construccion 
            nombreApartado="Rendición de Cuentas"
            enlace="http://www.haciendachiapas.gob.mx/rendicion-ctas/rendicion-ctas.asp">
        </pagina-construccion>
        
    </div>
</template>
<script>
import presupuestoEgreso from './Presupuesto-egresos'
import finanzasPublicas from './Finanzas-publicas'
import gestionFinanciera from './Gestion-financiera'
import recursosMunicipios from './Recursos-municipios'
import estrategicoMunucipal from './Estrategico-municipal'
import cuentasPublicas from './Cuentas-publicas'
import trimestralCuentas from './Trimestral-publicas'
import paginaConstruccion from './../Construccion'

export default {
    data: function(){
        return{
            PresupuestoEgreso: false, //este va en true
            finanzas: false,
            gestionfinanciera: false, 
            recursos: false,
            estrategicaMpal: false,
            ctaspublicas: false,
            trimestral: false,
        }
    },
    mounted(){
        window.scrollTo(0, 0);
    },
    components:{
        presupuestoEgreso,
        finanzasPublicas,
        gestionFinanciera,
        recursosMunicipios,
        estrategicoMunucipal,
        cuentasPublicas,
        trimestralCuentas,
        paginaConstruccion,
    },
    methods:{
        todas(){
            this.PresupuestoEgreso = false;
            this.finanzas = false;
            this.gestionfinanciera = false; 
            this.recursos = false;
            this.estrategicaMpal = false;
            this.ctaspublicas = false;
            this.trimestral = false;
        },
        opciones(valor){
            this.todas();
            if(valor == 1){ this.PresupuestoEgreso = true }
            if(valor == 2){ this.finanzas = true }
            if(valor == 3){ this.gestionfinanciera = true }
            if(valor == 4){ this.recursos = true }
            if(valor == 5){ this.estrategicaMpal = true }
            if(valor == 6){ this.ctaspublicas = true }
            if(valor == 7){ this.trimestral = true }
        },
      

    },
}
</script>

<style scoped>

.btn.focus, .btn:focus {
    outline: 0;
    box-shadow: none !important;
}


</style>